import { createFileRoute, notFound } from '@tanstack/react-router';
import { NotFoundPage } from './-components/not-found';

export const Route = createFileRoute('/www/$')({
	// A 200 would be a soft 404 that search engines index. Only a LOADER's `notFound()` sets the status
	// `renderRouterToStream` reads; `setResponseStatus` is dead here, as h3 ignores it once the SSR handler
	// returns a `Response`, which it always does (TEC-3629).
	loader: () => {
		throw notFound();
	},
	// Declared here too, so this 404 does not depend on `/www` keeping its own.
	notFoundComponent: NotFoundPage,
	// Rendered, not thrown in the component: a render-phase throw switches streamed SSR to client
	// rendering (the same trap as $portalId/route.tsx).
	component: NotFoundPage,
});
